export const getExamQuotaStatus = (user) => {
  if (!user) return null;

  const rawQuota = user.exam_quota;
  const used = Math.max(0, Number(user.exam_used || 0));

  if (rawQuota === null || rawQuota === undefined || Number(rawQuota) <= 0) {
    return {
      isUnlimited: true,
      remaining: null,
      used,
      total: null,
      percentUsed: 0,
      isEmpty: false,
      isLow: false,
    };
  }

  const total = Math.max(0, Number(rawQuota));
  const serverRemaining = user.exam_remaining;
  const remaining = serverRemaining !== null && serverRemaining !== undefined
    ? Math.max(0, Number(serverRemaining))
    : Math.max(0, total - used);
  const percentUsed = total ? Math.min(100, Math.round(((total - remaining) * 100) / total)) : 0;

  return {
    isUnlimited: false,
    remaining,
    used,
    total,
    percentUsed,
    isEmpty: remaining <= 0,
    isLow: remaining > 0 && remaining <= 2,
  };
};

export const formatExamQuotaLabel = (quota) => {
  if (!quota) return '--';
  return quota.isUnlimited ? 'Vô hạn' : `${quota.remaining} lượt`;
};
